import { createFileRoute, redirect, Outlet } from '@tanstack/react-router'
import { Suspense } from 'react'
import { SidebarProvider } from '@/components/ui/sidebar'
import { AppSidebar } from '@/components/layout/app-sidebar' 
import { Main } from '@/components/layout/main'
import useAuth from '@/hooks/use-auth'
import { cn } from '@/lib/utils'
import { isLocationDenied } from '@/lib/client-geolocation'
import { clearTokens } from '@/lib/axios'

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async () => {
    // If user denied location, force logout and redirect to location-required
    if (isLocationDenied()) {
      clearTokens();
      throw redirect({ to: '/location-required' });
    }

    // Get the auth state from local storage
    const token = localStorage.getItem('access_token');

    // If not authenticated, redirect to sign-in
    if (!token) {
      throw redirect({
        to: '/sign-in',
        search: {
          redirect: location.pathname,
        },
      })
    }
  },
  
  component: AuthenticatedLayout,
})

function AuthenticatedLayout() {
  const { isLoading } = useAuth();

  if (isLoading) {
    return <div className="flex items-center justify-center h-screen">Loading...</div>;
  }

  return (
    <SidebarProvider defaultOpen={true}>
      <AppSidebar />
      <div
        className={cn(
          'ml-auto w-full max-w-full',
          'peer-data-[state=collapsed]:w-[calc(100%-var(--sidebar-width-icon)-1rem)]',
          'peer-data-[state=expanded]:w-[calc(100%-var(--sidebar-width))]',
          'sm:transition-[width] sm:duration-200 sm:ease-linear',
          'flex h-svh flex-col',
        )}
      >
        <Main>
          <Suspense fallback={<div>Loading...</div>}>
            <Outlet />
          </Suspense>
        </Main>
      </div>
    </SidebarProvider>
  )
}
